import React, { memo, useCallback, useState } from 'react';
import { Button } from 'primereact/button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import config from '../../../../config';
import viewIcon from '../../../../assets/images/docs.svg';
import downloadIcon from '../../../../assets/images/download.svg';
import { downloadAttachment, viewAttachment } from '../row-actions/attachmentActions';

const NO_PACKET_TOOLTIP =
	'Credentials are not currently available for this shift. Please contact your ShiftMed Customer Support team.';

// View / download the credential packet generated for one worked shift. Without a packet the icons stay visible but
// disabled, with a tooltip pointing the user to Customer Support.
const ShiftHistoryPacketActions = ({ managementCompanyId, caregiverId, slotId, hasCredentialPacket }) => {
	const [hasError, setHasError] = useState(false);

	const packetUrl = `${config.API_URL}/on-demand-staff/management-companies/${managementCompanyId}/professionals/${caregiverId}/shift-history/${slotId}/credential-packet`;

	const onView = useCallback(async () => {
		if (!hasCredentialPacket) {
			return;
		}
		setHasError(false);
		try {
			await viewAttachment(packetUrl, managementCompanyId);
		} catch {
			setHasError(true);
		}
	}, [hasCredentialPacket, packetUrl, managementCompanyId]);

	const onDownload = useCallback(async () => {
		if (!hasCredentialPacket) {
			return;
		}
		setHasError(false);
		try {
			await downloadAttachment(packetUrl, managementCompanyId);
		} catch {
			setHasError(true);
		}
	}, [hasCredentialPacket, packetUrl, managementCompanyId]);

	const buttonClassName = classNames('btn actions', { 'download-disabled': !hasCredentialPacket });
	const viewTooltip = hasCredentialPacket ? 'View credentials' : NO_PACKET_TOOLTIP;
	const downloadTooltip = hasCredentialPacket ? 'Download credentials' : NO_PACKET_TOOLTIP;

	return (
		<div className="credential-actions">
			<div className="credential-actions-container">
				<OverlayTrigger
					placement="bottom-end"
					trigger={['hover']}
					overlay={<Tooltip className="download-permission-tooltip">{viewTooltip}</Tooltip>}
				>
					<Button type="button" className={buttonClassName} onClick={onView}>
						<img src={viewIcon} alt="View credentials" className="credential-action-icon" />
					</Button>
				</OverlayTrigger>
				<OverlayTrigger
					placement="bottom-end"
					trigger={['hover']}
					overlay={<Tooltip className="download-permission-tooltip">{downloadTooltip}</Tooltip>}
				>
					<Button type="button" className={buttonClassName} onClick={onDownload}>
						<img src={downloadIcon} alt="Download credentials" className="credential-action-icon" />
					</Button>
				</OverlayTrigger>
			</div>
			{hasError && (
				<span className="credential-action-error" role="alert">
					Something went wrong, please try again
				</span>
			)}
		</div>
	);
};

export default memo(ShiftHistoryPacketActions);
